import { render, staticRenderFns } from "./ContestOfferCard.vue?vue&type=template&id=82df237e&"
import script from "./ContestOfferCard.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ContestOfferCard.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports